import ExpertisesIndex from './expertises-index';

export default class ExpertisesIndexDesktop extends ExpertisesIndex {
    constructor(...args) {
        super(...args);
    }

    /**
     * init() {}
     * bind() {}
     * unbind() {}
     * resize(width, height) {}
     * _destroy() {}
     */
}



// WEBPACK FOOTER //
// ./src/js/pages/expertises/expertises-index.desktop.js